module.exports = __webpack_public_path__ + "static/img/male-4.cd848cb3.png";